/* Publish by EComposer at 2026-10-17 07:57:14*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mbf7tna6vs"]=  window.__ectimmers["ecom-mbf7tna6vs"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-mbf7tna6vs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mbf7tna6vs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y8q1pack31').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y8q1pack31', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7udyix8gvab').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7udyix8gvab', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8rrz04hdnlv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8rrz04hdnlv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-12dlcpwealdo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-12dlcpwealdo', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-jcf69krxrrn"]=  window.__ectimmers["ecom-jcf69krxrrn"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-jcf69krxrrn"]["6k86eej95"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-jcf69krxrrn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jcf69krxrrn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-03a2ux1bo3ys').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-03a2ux1bo3ys', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}